<template>
  <div className="section-row">
    <div className="section-row__parent">
      <div class="section-row__title">
        <slot name="title">
          <span v-html="props.title === null ? '-' : props.title"></span>
        </slot>
        <span class="section-row__subtitle" v-if="props.subTitle">
          {{ props.subTitle === null ? "-" : props.subTitle }}
        </span>
      </div>
      <div className="section-row__value">
        <SmallSpinner v-if="props.isLoading" />
        <div v-else>
          <slot name="value">
            <span
              class="font-bold"
              v-html="props.value === null ? '-' : props.value"
            ></span>
          </slot>
          <span class="section-row__subvalue" v-if="props.subValue">
            {{ props.subValue === null ? "-" : props.subValue }}
          </span>
        </div>
      </div>
    </div>
    <HelpText :text="props.helpText" />
    <div className="section-row__subrows">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import HelpText from "@/components/ui/HelpText.vue";
import SmallSpinner from "@/components/ui/SmallSpinner.vue";

export type TitleValueProps = {
  title: string;
  value?: string | number | null;
  subTitle?: string | number | null;
  subValue?: string | number | null;
  helpText?: string;
  isLoading?: boolean;
};

const props = defineProps<TitleValueProps>();
</script>

<style scoped>
.section-row {
  position: relative;
  border-bottom: 1px solid var(--neutral-200);
}

.section-row__parent {
  display: flex;
  justify-content: space-between;
  padding: 0.6em 0;
}

.section-row__value > div {
  display: flex;
  flex: 1;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.5em;
}

.section-row__title {
  display: flex;
  flex: 1;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.5em;
}

.section-row__subtitle {
  color: var(--neutral-700);
}

.section-row__subvalue {
  color: var(--neutral-700);
}

:slotted(.section-row) {
  border-bottom: none;
  padding-left: 2em;
}

.section-row__subrows .section-row:before {
  display: block;
  position: absolute;
  bottom: 50%;
  left: 0.7em;
  border-bottom: 1px solid var(--neutral-50);
  border-left: 1px solid var(--neutral-50);
  background: clear;
  width: 1em;
  height: 50%;
  content: "";
}

.section-row__subrows .section-row:not(:last-child):after {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0.7em;
  border-left: 1px solid var(--neutral-50);
  background: clear;
  width: 1em;
  height: 50%;
  content: "";
}
</style>
